<div class="col-12">
    <div class="card form-heading" reflow="true">
        <h5>{{'FARMER_APPLICATION_DETAILS' | translate}}</h5>
    </div>

    <div class="card" reflow="true">

        <div class="consent-form border" id="printableArea">
            <div class="header border">
                <div class="col-4">{{ currentDateTime | date }}</div>
                <div class="col-4">
                    {{'VENDOR_ESTIMATION_FORM_FOR_MICRO_IRRIGATION_SCHEME'| translate}}
                </div>
                <div class="col-4">
                    <p-image *ngIf="applicationDetails?.FarmerPersonalData?.Farmer_Photo"
                        [src]="applicationDetails?.FarmerPersonalData?.Farmer_Photo" alt="Image" width="150"
                        class="ml-2" iconPos="left"></p-image>

                </div>
            </div>
            <div class="sub-header ">
                <table class="border">
                    <tr>
                        <td>
                            <p class="head">{{'APPLICATION_NO'| translate}}</p>
                            <a class="bold appId" (click)="onClickApp()">{{applicationDetails?.AppID}}</a>
                        </td>
                        <td>
                            <p class="head">{{'VENDOR_NAME'| translate}}</p>
                            <p class="bold">{{applicationDetails?.VendorName}}</p>
                        </td>
                        <td>
                            <p class="head">{{'PROGRAMME_NAME'| translate}}</p>
                            <p class="bold">
                                {{applicationDetails?.ProgrammeName}}
                            </p>
                        </td>
                    </tr>
                </table>
                <!-- <div class="col-3 border">
          </div>
          <div class="col-4 border">
  
          </div>
          <div class="col-5 border">
  
          </div> -->
            </div>

            <!-- member details -->
            <ng-container
                *ngIf="applicationDetails?.EstimationComponentDetail && applicationDetails?.EstimationComponentDetail.length>0">

                <div class="print border bold">{{'ESTIMATION_COMPONENT_DETAIL'| translate}}</div>
                <div class="table">
                    <table class="border">
                        <tr>
                            <th>{{'CAT_ID'| translate}}</th>
                            <th>{{'CAT_NAME'| translate}}</th>
                            <th>{{'COMPONENT_ID'| translate}}</th>
                            <th>{{'COMPONENT_NAME'| translate}}</th>
                            <th>{{'SIZE_ID'| translate}}</th>
                            <th>{{'SIZE'| translate}}</th>
                            <th>{{'PRICE'| translate}}</th>
                            <th>{{'QUANTITY'| translate}}</th>
                            <th>{{'GST'| translate}}</th>
                        </tr>
                        <tr *ngFor="let item of applicationDetails?.EstimationComponentDetail">
                            <td>{{item.CatID}}</td>
                            <td>{{item.CatName}}</td>
                            <td>{{item.ComponentID}}</td>
                            <td>{{item.ComponentName}}</td>
                            <td>{{item.SizeID}}</td>
                            <td>{{item.Size}}</td>
                            <td>{{item.Price}}</td>
                            <td>{{item.Quantity}}</td>
                            <td>{{item.GST}}</td>
                        </tr>
                    </table>
                </div>
            </ng-container>
            <!-- member details end -->

            <ng-container *ngIf="applicationDetails">

                <div class="print border bold ">{{'ESTIMATION_DETAILS'| translate}}</div>
                <div class="table">
                    <table class="border">
                        <tr>
                            <td>
                                <p class="bold">{{'VENDOR_ASSOCIATE_ID'| translate}}</p>
                                <p>{{applicationDetails?.VendorAssociateID}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'FARMER_SHARE_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.FarmerShareAmount}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'COMPONENT_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.ComponentAmount}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'TAX_RATE'| translate}}</p>
                                <p>{{applicationDetails?.TaxRate}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'DISCOUNT_RATE'| translate}}</p>
                                <p>{{applicationDetails?.DiscountRate}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'OTHER_TRANSPORT_EXPENSES'| translate}}</p>
                                <p>{{applicationDetails?.TransportOtherExpenses}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'MAX_SUBSIDY_AMOUNT'| translate}}</p>
                                <p>{{applicationDetails?.MaxSubSidyAmount}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'MI_AREA'| translate}}</p>
                                <p>{{applicationDetails?.MIArea}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'CROP_ID'| translate}}</p>
                                <p>{{applicationDetails?.CropID}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'LAND_MAP_PATH'| translate}}</p>
                                <p><a href="{{applicationDetails?.LandMapPath}}" target="_blank">open path</a></p>
                            </td>
                            <td>
                                <p class="bold">{{'LATITUDE'| translate}}</p>
                                <p>{{applicationDetails?.Lat}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'LONGITUDE'| translate}}</p>
                                <p>{{applicationDetails?.Long}}</p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p class="bold">{{'PLANT_SPACING'| translate}}</p>
                                <p>{{applicationDetails?.PlantSpacing}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'ROW_SPACING'| translate}}</p>
                                <p>{{applicationDetails?.RowSpacing}}</p>
                            </td>
                            <td>
                                <p class="bold">{{'REMARKS'| translate}}</p>
                                <p>{{applicationDetails?.Remarks}}</p>
                            </td>
                        </tr>
                    </table>
                </div>
            </ng-container>



        </div>
        <!-- <div class="flex justify-content-around mb-2">
            <button pButton pRipple icon="pi pi-print" type="submit" label="Print"
              (click)="onPrint('printableArea')"></button>
        </div> -->

        <!-- pre-estimate-survey -->
        <div class="pre-estimate-form border my-4" *ngIf="preEstimationDataArray.length > 0">
            <div class="mt-2 form-name">
                <h5> {{'PRE_ESTIMATE_SURVEY' | translate}} </h5>
            </div>

            <div class="consent-form" *ngFor="let preEstimateDetails of preEstimationDataArray">
                <ng-container>
                    <div class="table">
                        <table class="border">
                            <tr>
                                <td>
                                    <p class="bold">{{'APP_ID' | translate}}</p>
                                    <p>{{ preEstimateDetails?.AppID }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'PROGRAMME_NAME' | translate}}</p>
                                    <p>{{ preEstimateDetails?.ProgramName }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'SOIL_TYPE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.SoilType }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'CROP_TYPE' | translate}}</p>
                                    <p>
                                        {{ preEstimateDetails?.selectedCropType }}
                                    </p>
                                </td>
                                <td>
                                    <p class="bold">{{'CROP_NAME' | translate}}</p>
                                    <p>
                                        {{ preEstimateDetails?.selectedCrop }}
                                    </p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_SOURCE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterSource }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'WATER_PRESSURE' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterPressure }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_QUALITY' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterQuality }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'WATER_REQ' | translate}}</p>
                                    <p>{{ preEstimateDetails?.WaterQuantity }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'PH' | translate}}</p>
                                    <p>{{ preEstimateDetails?.PH }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'EC' | translate}}</p>
                                    <p>{{ preEstimateDetails?.EC }}</p>
                                </td>
                                <td>
                                    <p class="bold">{{'DATE_OF_SURVEY' | translate}}</p>
                                    <p>{{ preEstimateDetails?.DateOfSurvey }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p class="bold">{{'PLANT_SPACING' | translate}}</p>
                                    <p>{{ preEstimateDetails?.PlantSpacing }}</p>
                                </td>

                                <td>
                                    <p class="bold">{{'ROW_SPACING' | translate}}</p>
                                    <p>{{ preEstimateDetails?.RowSpacing }}</p>
                                </td>
                            </tr>
                        </table>
                        <div class="print border bold">
                            {{'LIST_GPS_COORDINATES' | translate}}
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <th>{{'CORNER_ID' | translate}}</th>
                                    <th>{{'LATITUDE' | translate}}</th>
                                    <th>{{'LONGITUDE' | translate}}</th>
                                </tr>
                                <tr *ngFor="let item of preEstimateDetails.listGPSCoordinates">
                                    <td>{{item.CornerID}}</td>
                                    <td>{{item.Latitude}}</td>
                                    <td>{{item.Longitude}}</td>
                                </tr>
                            </table>
                        </div>
                        <div class="p-fluid p-formgrid grid hidden-print" *ngIf="showMapPreEstimate">
                            <div class="field col-12 md:col-12">
                                <p-gmap [options]="preEstimateDetails?.optionsPreEstimate" type="satellite"
                                    [overlays]="preEstimateDetails?.overlaysPreEstimate"
                                    [style]="{'width':'100%','height':'320px'}"></p-gmap>
                            </div>
                        </div>
                        <div class="print border bold">
                            {{'LIST_IMAGE_PATH' | translate}}
                        </div>
                        <div class="table">
                            <table class="border">
                                <tr>
                                    <th>{{'IMAGE_PATH' | translate}}</th>
                                    <th>{{'DOCUMENT_TYPE' | translate}}</th>
                                </tr>
                                <tr *ngFor="let item of preEstimateDetails.listImagePath">
                                    <td><a style="cursor: pointer" [href]="item.ImagePath"
                                            target="_blank">{{'VIEW_IMAGE' |
                                            translate}}</a></td>
                                    <td>{{item.DocumentType}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
        <!-- pre-estimate-survey end-->
    </div>
</div>

<div class="card proDataCalculation">
    <!-- <div> -->
    <!-- pro data calculations -->
    <div class="my-2 proDataButton">
        <button (click)="proDataCalculation()" pButton pRipple type="submit"
            label="{{'VIEW_PRO_DATA_MAX_SUBSIDY_CAL'| translate}}" class="p-button-info mr-2 mb-2"></button>
    </div>
    <!-- <div *ngIf="showProDataCalError" class="invalid-feedback mb-2">
            <div *ngIf="finalEstimationControls?.rowSpacing?.errors?.required">Row Spacing is
                required
            </div>
            <div *ngIf="finalEstimationControls?.plantSpacing?.errors?.required">Plant Spacing is
                required
            </div>
            <div *ngIf="finalEstimationControls?.MIArea?.errors?.required">MIArea Spacing is
                required
            </div>
        </div> -->

    <div *ngIf="isProDataCalculated" class="p-fluid p-formgrid grid card proData">
        <div class="field col-12 md:col-3">
            <label htmlFor="pro-data">{{'PRO-DATA_MAX-SUBSIDY_FORMULA'| translate}}:</label>
            <p><label>{{ proCalculatedData.Formula }}</label></p>
        </div>

        <div class="field col-12 md:col-3">
            <label htmlFor="output">{{'OUTPUT'| translate}} :</label>
            <p><label>{{ proCalculatedData.Output }}</label></p>
        </div>

        <div class="field col-12 md:col-2">
            <label htmlFor="amount">{{'AMOUNT'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.Amount }}/-</label></p>
        </div>

        <div class="field col-12 md:col-1">
            <label htmlFor="maxSubsidy">{{'MAXIMUN_SUBSIDY'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.maxSubsidy }}/-</label></p>
        </div>

        <div class="field col-12 md:col-1">
            <label htmlFor="transportAmount">{{'TRANSPORT_AMOUNT'| translate}} :</label>
            <p><label>Rs. {{ proCalculatedData.TransportAmount }}/-</label></p>
        </div>

        <div class="field col-12 md:col-2">
            <label htmlFor="result">{{'RESULT'| translate}} :</label>
            <p><label>{{ proCalculatedData.Result }}</label></p>
        </div>

    </div>

    <!-- </div> -->
</div>

<div class="card" *ngIf="isActionSectionEnabled">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right">
            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3"></p-dropdown>
            <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea
                required rows="3" cols="20" class="mr-3"></textarea>
            <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="handleClick()"
                class="p-button-help"></button>
        </ng-template>
    </p-toolbar>
</div>